import Response from "./Response";

const CLASSES = {
    Response
}

export default CLASSES;
